import React, { useState, useMemo } from 'react';
import isToday from 'date-fns/isToday';
import PropTypes from 'prop-types';

import { DatePicker } from '../../../../components/DatePicker';
import { FormField } from '../../../../components/Form/components/FormField';
import { ConfirmationModal } from '../confirmationModal';

const Purge = ({ closeDialog, onPurge }) => {
    const [maxDate, setMaxDate] = useState();
    const todaySelected = useMemo(() => {
        return (maxDate && isToday(maxDate)) || false;
    }, [maxDate]);

    return (
        <ConfirmationModal
            header={`Purge Deployment Queue`}
            body={
                <>
                    <span>
                        Are you sure you want to clear the deployment queue?{' '}
                        <strong>
                            This action is irreversible and will affect any pending, active, and completed deployment
                            queue items.
                        </strong>
                    </span>
                    <FormField label={'Purge all before'} labelFor={'purgeFromDatePicker'} required>
                        <DatePicker
                            id="purgeFromDatePicker"
                            selected={maxDate}
                            onChange={(date) => setMaxDate(date)}
                            placeholderText="Please select a date"
                            isClearable
                            maxDate={new Date()}
                            filterTime={
                                todaySelected
                                    ? (time) => {
                                          const currentDate = new Date();
                                          const selectedDate = new Date(time);

                                          return currentDate.getTime() > selectedDate.getTime();
                                      }
                                    : undefined
                            }
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            required
                        />
                    </FormField>
                </>
            }
            confirmButtonText={'Purge Queue'}
            confirmButtonProps={{ appearance: 'destructive', disabled: !maxDate }}
            closeDialog={closeDialog}
            onConfirm={() => {
                return onPurge(maxDate);
            }}
        />
    );
};

Purge.propTypes = {
    onPurge: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired
};

export default Purge;